import { render, staticRenderFns } from "./PatientAttachmentsInfo.vue?vue&type=template&id=c141487e&"
import script from "./PatientAttachmentsInfo.vue?vue&type=script&lang=js&"
export * from "./PatientAttachmentsInfo.vue?vue&type=script&lang=js&"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports